import { ConfirmTypeEnum, type CustomerQuote } from '@talos/kyoko';
import { otcRepoRFQPricingFormHandler } from './OTCRepoRFQPricingForm/OTCRepoRFQPricingFormState';
import { rfqPricingFormHandler } from './RFQPricingForm/RFQPricingFormState';
import type { ManualRFQPricingFormHandler, ManualRFQPricingFormKey, ManualRFQPricingState } from './types';

export const DEFAULT_MANUAL_RFQ_PRICING_FORM_KEY: ManualRFQPricingFormKey = 'form';

const manualRFQPricingFormHandlers: Record<ManualRFQPricingFormKey, ManualRFQPricingFormHandler> = {
  form: rfqPricingFormHandler,
  otcRepoForm: otcRepoRFQPricingFormHandler,
};

export function getActiveFormKeyForCustomerQuote(quote: CustomerQuote): ManualRFQPricingFormKey {
  if (quote.ConfirmType === ConfirmTypeEnum.RepoConfirm) {
    return 'otcRepoForm';
  }

  return DEFAULT_MANUAL_RFQ_PRICING_FORM_KEY;
}

export function getActiveManualRFQPricingFormHandler(
  state: Pick<ManualRFQPricingState, 'activeFormKey'>
): ManualRFQPricingFormHandler {
  return getManualRFQPricingFormHandler(state.activeFormKey);
}

export function getManualRFQPricingFormHandler(formKey: ManualRFQPricingFormKey): ManualRFQPricingFormHandler {
  return manualRFQPricingFormHandlers[formKey];
}
